(function () {
  const mediaQuery = window.matchMedia('(min-width: 1200px)');

  const navCollapse = document.getElementById('navbarSupportedContent');
  if (!navCollapse) return;

  const nav = navCollapse.querySelector('.navbar-nav');
  if (!nav) return;

  const firstDropdown = () => nav.querySelector('.nav-item.dropdown');
  const firstToggle   = () => firstDropdown()?.querySelector('.nav-link.dropdown-toggle');
  const firstMenu     = () => firstDropdown()?.querySelector('.dropdown-menu');

  const isShown = () => !navCollapse.classList.contains('collapse') || navCollapse.classList.contains('show');

  let autoActive = false;
  let bound = false;

  const bsDropdownFor = (toggleEl) =>
    (toggleEl && window.bootstrap && window.bootstrap.Dropdown)
      ? window.bootstrap.Dropdown.getOrCreateInstance(toggleEl, { autoClose: true })
      : null;

  function openFirst() {
    const toggleEl = firstToggle(), menuEl = firstMenu();
    if (!toggleEl || !menuEl) return;

    // Andere Menüs schließen
    nav.querySelectorAll('.nav-item.dropdown .nav-link.dropdown-toggle.show').forEach(el => {
      if (el !== toggleEl) bsDropdownFor(el)?.hide?.();
      if (el !== toggleEl) { el.classList.remove('show'); el.setAttribute('aria-expanded','false'); }
    });
    nav.querySelectorAll('.nav-item.dropdown .dropdown-menu.show').forEach(el => {
      if (el !== menuEl) el.classList.remove('show');
    });

    const api = bsDropdownFor(toggleEl);
    if (api && typeof api.show === 'function') {
      api.show();
    } else {
      toggleEl.classList.add('show', 'position-relative');
      toggleEl.setAttribute('aria-expanded', 'true');
      menuEl.classList.add('show');
      menuEl.setAttribute('data-bs-popper', 'static');
    }
    autoActive = true;
  }

  function closeFirst() {
    const toggleEl = firstToggle(), menuEl = firstMenu();
    if (!toggleEl || !menuEl) { autoActive = false; return; }
    bsDropdownFor(toggleEl)?.hide?.();
    toggleEl.classList.remove('show');
    toggleEl.setAttribute('aria-expanded','false');
    menuEl.classList.remove('show');
    menuEl.removeAttribute('data-bs-popper');
    autoActive = false;
  }

  function applyDesktop() {
    if (isShown()) {
      // Nur auto-öffnen, wenn kein anderes Dropdown schon offen ist
      const anyOtherOpen = nav.querySelector('.nav-item.dropdown .nav-link.dropdown-toggle.show:not(.nav-item:first-child .nav-link)');
      if (!anyOtherOpen) openFirst();
    } else {
      closeFirst();
    }
  }

function forceCloseDropdown(toggleEl){
  if (!toggleEl) return;
  const dropdownItem = toggleEl.closest('.nav-item.dropdown');
  const menu = dropdownItem?.querySelector('.dropdown-menu');

  toggleEl.classList.remove('show');
  toggleEl.setAttribute('aria-expanded', 'false');

  if (menu) {
    menu.classList.remove('show');
    menu.removeAttribute('data-bs-popper');
  }
}

function closeAllExcept(keepToggle){
  nav.querySelectorAll('.nav-item.dropdown .dropdown-toggle').forEach(t => {
    if (keepToggle && t === keepToggle) return;
    forceCloseDropdown(t);
  });
}
function onToggleClickCapture(e){
  if (!mediaQuery.matches) return; // nur Desktop
  const toggle = e.target.closest('.dropdown-toggle');
  if (!toggle || !nav.contains(toggle)) return;

  closeAllExcept(toggle);

  // wenn du dein "autoActive" weiter nutzen willst:
  autoActive = (toggle === firstToggle());
}
nav.addEventListener('click', onToggleClickCapture, true); // capture = true

// Zweiter Klick auf einen bereits offenen Toggle soll das Dropdown NICHT schließen.
// Bootstrap registriert seinen eigenen Klick-Handler intern per Event-Delegation,
// wodurch er (auch ohne das explizit anzugeben) im Capture-Modus auf `document`
// läuft – also VOR jedem eigenen click-Listener, egal ob capture oder bubble.
// Das Zuklappen lässt sich daher nicht über den click abfangen, sondern nur über
// das von Bootstrap ausgelöste, abbrechbare `hide.bs.dropdown`-Event: Wir merken
// uns per mousedown, ob der Toggle schon offen war, und verhindern in diesem Fall
// das nachfolgende Hide.
let reopenGuard = null;

nav.addEventListener('mousedown', function (e) {
  if (!mediaQuery.matches) { reopenGuard = null; return; }
  const toggle = e.target.closest('.dropdown-toggle');
  reopenGuard = (toggle && nav.contains(toggle) && toggle.classList.contains('show')) ? toggle : null;
});

document.addEventListener('hide.bs.dropdown', function (e) {
  if (reopenGuard && e.target === reopenGuard) {
    e.preventDefault();
  }
  reopenGuard = null;
});


  // --- Event-Handler (werden nur im Desktop-Setup registriert) ---
  function onShownCollapse(e){ if (e.target === navCollapse) applyDesktop(); }
  function onHiddenCollapse(e){ if (e.target === navCollapse) closeFirst(); }
  function onNavClick(e){
    if (!autoActive) return;
    const isFirst = !!e.target.closest('.nav-item.dropdown:first-child');
    if (!isFirst) closeFirst();
  }
  function onShowDropdown(e){
    if (!autoActive) return;
    const dropdownEl = e.target; // .dropdown
    if (!firstDropdown() || !dropdownEl) return;
    if (!firstDropdown().isSameNode(dropdownEl)) closeFirst();
  }

  function setupDesktop() {
    if (bound) return;
    bound = true;
    applyDesktop();
    document.addEventListener('shown.bs.collapse', onShownCollapse);
    document.addEventListener('hidden.bs.collapse', onHiddenCollapse);
    nav.addEventListener('click', onNavClick);
    document.addEventListener('show.bs.dropdown', onShowDropdown);
  }

  function teardownDesktop() {
    if (!bound) return;
    bound = false;
    // Zustände zurücksetzen & nichts mehr anfassen
    closeFirst();
    document.removeEventListener('shown.bs.collapse', onShownCollapse);
    document.removeEventListener('hidden.bs.collapse', onHiddenCollapse);
    nav.removeEventListener('click', onNavClick);
    document.removeEventListener('show.bs.dropdown', onShowDropdown);
  }

  function handleMQ(e){
    if (e.matches) {        // ≥ 1200px
      setupDesktop();
    } else {                // < 1200px
      teardownDesktop();    // komplett deaktivieren
    }
  }

  // Initial & Listener
  handleMQ(mediaQuery);
  mediaQuery.addEventListener ? mediaQuery.addEventListener('change', handleMQ) : mediaQuery.addListener(handleMQ);
})();

//UO-Accessibility
import UoAccessability from "./modules/uo-accessibility/uo-accessibility";

document.addEventListener("DOMContentLoaded", function () {
	const uoAccessability = new UoAccessability({
		overwriteFocusVisibleStyles: true,
        hiddenClass: "uo-accessibility-hidden", // BS >= 5: visually-hidden, BS < 5: sr-only
		ariaLabels: {
			'de-DE': 'Sprungnavigation',
			'en-EN': 'Skip links navigation'
		},
		helper: [
			{                
				helperName: {
					'de-DE': "Hauptnavigation",
					'en-EN': "Main menu"
				},
				targetSelector: "header .navbar-toggler",
				anchorID: "uo-target-nav",
				linkText: {
					'de-DE': "Direkt zur Hauptnavigation",
					'en-EN': "Skip to main menu"
				}			
			},
			{
				helperName: {
					'de-DE': "Inhalt",
					'en-EN': "Content",
				},
				targetSelector: "main",
				anchorID: "uo-target-content",
				linkText: {
					'de-DE': "Direkt zum Inhalt",
					'en-EN': "Skip to content"
				}
			},
			{
				helperName: {
					'de-DE': "Footer",
					'en-EN': "Footer"
				},
				targetSelector: "footer",
				anchorID: "uo-target-footer",
				linkText: {
					'de-DE': "Direkt zum Footer",
					'en-EN': "Skip to footer"
				}
			},
		],
	});

});
//UO-Accessibility END

// Video Player

if (document.querySelectorAll('.videoplayer').length) {
    const videos = document.querySelectorAll('.videoplayer');
    videos.forEach(function(video){
        video.addEventListener('click', function(){
            video.classList.add('clicked');
        });
        video.addEventListener('touchend', function(){
            video.classList.add('clicked');
        });
    });
}

// Video Player END

// progress


// progress bar
// progress bar
var progressBar = document.getElementById("myBar");

// Nur wenn das Element existiert, Event Listener registrieren
if (progressBar) {
  var progressContainer = progressBar.closest('.progress-container');

  function updateProgressBar() {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var scrolled = height > 0 ? (winScroll / height) * 100 : 0;

    if (progressContainer) {
      progressContainer.style.display = winScroll > 0 ? '' : 'none';
    }

    progressBar.style.width = scrolled + "%";
  }

  updateProgressBar();
  window.addEventListener("scroll", updateProgressBar);
}

// progress button
$(document).ready(function () {
    "use strict";

    var progressPath, pathLength;

    function initProgressBar() {
        if ($(window).width() >= 1200) {
            if (!$('.progress-wrap path').length) return;

            progressPath = document.querySelector('.progress-wrap path');
            pathLength = progressPath.getTotalLength();

            progressPath.style.transition = 'none';
            progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = 'stroke-dashoffset 10ms linear';

            var updateProgress = function () {
                var scroll = $(window).scrollTop();
                var height = $(document).height() - $(window).height();
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            };

            updateProgress();
            $(window).off('scroll', updateProgress).on('scroll', updateProgress);

            var offset = 50;
            var duration = 550;

            $(window).off('scroll.progress').on('scroll.progress', function () {
                if ($(this).scrollTop() > offset) {
                    $('.progress-wrap').addClass('active-progress');
                } else {
                    $('.progress-wrap').removeClass('active-progress');
                }
            });

            $('.progress-wrap').off('click').on('click', function (event) {
                event.preventDefault();
                $('html, body').animate({ scrollTop: 0 }, duration);
                return false;
            });

        } else {
            $(window).off('scroll.progress');
            $('.progress-wrap').removeClass('active-progress');

            if (progressPath) {
                progressPath.style.strokeDashoffset = pathLength; 
            }
        }
    }

    initProgressBar();

    $(window).on('resize', function () {
        initProgressBar();
    });
});

import jquery from 'jquery';
import $ from "jquery";

// progress END

//Check if sticky-nav
document.addEventListener("DOMContentLoaded", function () {
    const stickyNavElements = document.querySelectorAll(".sticky-nav");

    if (stickyNavElements.length > 0) {
        document.body.classList.add("has-sticky-nav");
    }
});
//Check if sticky-nav END

//sticky-element 

document.addEventListener("DOMContentLoaded", function () {
	
	const spanElements = document.querySelectorAll(".sticky-nav ul li span");
	const ulElement = document.querySelector(".sticky-nav ul");
	let activeLiElement = null;	

	if(ulElement && spanElements) {

		spanElements.forEach(function (span) {
			let liElement = span.closest("li");

			function openCloseAction() {				
				toggleActive(liElement);
				// console.log("liElement: " + liElement);
			}

			span.addEventListener("click", openCloseAction);

			// open and close elements with tab			
			document.addEventListener("keyup", (event) => {
				if (event.key === 'Tab') {
					
					if (event.target === liElement.querySelector(".sticky-nav-content a")) {
						openCloseAction();
					}

					ulElement.addEventListener("focusout", (event) => {
						setTimeout(() => {
							if (!ulElement.contains(document.activeElement)) {
								toggleActive(activeLiElement);
							}
						}, 0);
					});

				}
			});

		});

		document.addEventListener("click", function (event) {

				if (!event.target.closest(".sticky-nav ul")) {
					toggleActive(activeLiElement);
				}
				
		});

		window.addEventListener("resize", function () {
			
				ulElement.classList.remove("has-active");
				if (activeLiElement) {
					activeLiElement.classList.remove("active");
					ulElement.style.marginBottom = "0";
					activeLiElement = null;
				}

		});

	}

	function toggleActive(liElement) {

		if (!liElement) {
			return;
		}

		if (liElement === activeLiElement) {
			ulElement.classList.remove("has-active");
			liElement.classList.remove("active");
			ulElement.style.marginBottom = "0";
			activeLiElement = null;
		} else {
			ulElement.classList.add("has-active");

			if (activeLiElement) {
				activeLiElement.classList.remove("active");
			}

			
			liElement.classList.add("active");
			if (window.innerWidth < 992) {
				ulElement.style.marginBottom = liElement.getElementsByClassName("sticky-nav-content")[0].offsetHeight + "px";
			}
			activeLiElement = liElement;
		}
	}

});

//sticky-element END


// // Service-Finder Content-Element: Weiter-Button aktivieren/deaktivieren basierend auf Auswahl
// document.addEventListener('DOMContentLoaded', function() {
//     // Alle Service-Select Elemente finden (sowohl im Service-Finder als auch in Sticky-Nav)
//     var serviceSelects = document.querySelectorAll('[id^="serviceSelect-"]');

//     serviceSelects.forEach(function(serviceSelect) {
//         // Die UID aus der ID extrahieren
//         var uid = serviceSelect.id.replace('serviceSelect-', '');
//         var weiterBtn = document.getElementById('weiterBtn-' + uid);

//         if (!weiterBtn) {
//             console.warn('Weiter-Button nicht gefunden für UID:', uid);
//             return;
//         }

//         // Event Listener für Änderungen im Select
//         serviceSelect.addEventListener('change', function() {
//             var selectedLink = this.value;
//             if (selectedLink && selectedLink !== '') {
//                 weiterBtn.setAttribute('href', selectedLink);
//                 weiterBtn.style.pointerEvents = 'auto';
//                 weiterBtn.style.opacity = '1';
//             } else {
//                 weiterBtn.setAttribute('href', '#');
//                 weiterBtn.style.pointerEvents = 'none';
//                 weiterBtn.style.opacity = '0.5';
//             }
//         });

//         // Initial state: Button deaktiviert bis Service ausgewählt
//         weiterBtn.style.pointerEvents = 'none';
//         weiterBtn.style.opacity = '0.5';
//     });
// });

// Service-Finder Content-Element: Weiter-Link (a) barrierefrei aktivieren/deaktivieren basierend auf Auswahl
document.addEventListener('DOMContentLoaded', function () {
  // Alle Service-Select Elemente finden (sowohl im Service-Finder als auch in Sticky-Nav)
  var serviceSelects = document.querySelectorAll('[id^="serviceSelect-"]');

  // Hilfsfunktion: Link-Button Zustand setzen (ohne opacity-trick)
  function setLinkButtonState(linkEl, href) {
    var disabled = !href || href === '';

    linkEl.classList.toggle('is-disabled', disabled);
    linkEl.setAttribute('aria-disabled', String(disabled));

    if (disabled) {
      linkEl.dataset.href = '';
      linkEl.removeAttribute('href');     // kein "#" setzen
      linkEl.setAttribute('tabindex', '-1');
      linkEl.style.pointerEvents = 'none';
    } else {
      linkEl.dataset.href = href;
      linkEl.setAttribute('href', href);
      linkEl.setAttribute('tabindex', '0');
      linkEl.style.pointerEvents = 'auto';
    }
  }

  serviceSelects.forEach(function (serviceSelect) {
    // Die UID aus der ID extrahieren
    var uid = serviceSelect.id.replace('serviceSelect-', '');
    var weiterBtn = document.getElementById('weiterBtn-' + uid);

    if (!weiterBtn) {
      console.warn('Weiter-Button nicht gefunden für UID:', uid);
      return;
    }

    // Initial state: Link deaktiviert bis Service ausgewählt
    setLinkButtonState(weiterBtn, '');

    // Event Listener für Änderungen im Select
    serviceSelect.addEventListener('change', function () {
      var selectedLink = this.value;
      setLinkButtonState(weiterBtn, selectedLink);
    });
  });

  // Extra-Schutz: Falls ein deaktivierter Link doch geklickt wird (z.B. durch anderes JS)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[aria-disabled="true"]');
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
  });
});


// Map
// 1) SnazzyMaps-Style hier einfügen:
  const snazzyStyle = [
    {
        "featureType": "landscape.natural",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#88cdd3"
            },
            {
                "lightness": "18"
            },
            {
                "saturation": "0"
            },
            {
                "gamma": "2.65"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#88cdd3"
            },
            {
                "gamma": "1.68"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 100
            },
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "lightness": 700
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#88cdd3"
            }
        ]
    }
];

window.initMap = function () {
  const center = { lat: 51.4825, lng: 11.9705 }; // Beispiel: Halle (Saale)

    const map = new google.maps.Map(document.getElementById("map"), {
      center: center,
      zoom: 14,
      styles: snazzyStyle, // <- hier wird der Snazzy-Style angewendet
      disableDefaultUI: false
    });

    // optional: Marker
    new google.maps.Marker({
      position: center,
      map: map,
      title: "BWG Halle"
    });
};


//BS Popovers
import Popover from 'bootstrap/js/dist/popover.js'
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl))

// Fix für iOS, weil iOS kein trigger focus kann

// Close all popovers when clicking outside
document.addEventListener('click', (event) => {
  // Check if click was inside a popover trigger
  const triggerClicked = event.target.closest('[data-bs-toggle="popover"]');

  // Wenn der Klick nicht auf einen Trigger geht, schließe alle Popovers
  if (!triggerClicked) {
    popoverList.forEach((popover) => popover.hide());
    return;
  }

  // Wenn auf denselben Trigger erneut geklickt wurde → toggle
  const popoverInstance = Popover.getInstance(triggerClicked);
  if (popoverInstance) {
    // Wenn das Popover sichtbar ist → schließen
    if (triggerClicked.classList.contains('show')) {
      popoverInstance.hide();
    } else {
      // Erst alle anderen schließen
      popoverList.forEach((p) => p.hide());
      popoverInstance.show();
    }
  }
});
//BS Popovers END


// Focus Trap für Navigation (Barrierefreiheit)
(function() {
  const navToggler = document.querySelector('.navbar-toggler');
  const navCollapse = document.getElementById('navbarSupportedContent');
  
  if (!navToggler || !navCollapse) return;

  // Funktion zum Finden aller fokussierbaren Elemente
  function getFocusableElements() {
    const focusableSelectors = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const focusableInNav = Array.from(navCollapse.querySelectorAll(focusableSelectors));
    return focusableInNav.filter(el => {
      // Nur sichtbare Elemente
      return el.offsetParent !== null;
    });
  }

  // Event Listener für Keydown
  function handleNavKeydown(event) {
    // Nur wenn Navigation geöffnet ist
    if (!navCollapse.classList.contains('show')) return;
    
    // Nur Tab-Taste
    if (event.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    if (focusableElements.length === 0) return;

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    
    // Shift + Tab auf dem ersten Element → Fokus auf Toggler
    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      navToggler.focus();
    }
    // Tab auf dem letzten Element → Fokus auf Toggler
    else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      navToggler.focus();
    }
  }

  // Event Listener für Tab vom Toggler zur Navigation
  function handleTogglerKeydown(event) {
    // Nur wenn Navigation geöffnet ist und Tab (ohne Shift) gedrückt wird
    if (!navCollapse.classList.contains('show')) return;
    if (event.key !== 'Tab' || event.shiftKey) return;

    const focusableElements = getFocusableElements();
    if (focusableElements.length > 0) {
      event.preventDefault();
      focusableElements[0].focus();
    }
  }

  // Event Listener hinzufügen
  navCollapse.addEventListener('keydown', handleNavKeydown);
  navToggler.addEventListener('keydown', handleTogglerKeydown);

  console.log('Navigation Focus Trap initialisiert');
})();
// Focus Trap END


// Mobile Menü Back Navigation
(function() {
  const navCollapse = document.getElementById('navbarSupportedContent');
  if (!navCollapse) return;

  navCollapse.addEventListener('click', function(e) {
    const backLink = e.target.closest('li.back a');
    if (!backLink) return;

    e.preventDefault();
    e.stopPropagation();

    // Find the current dropdown menu and close it
    const dropdownMenu = backLink.closest('.dropdown-menu');
    if (dropdownMenu) {
      dropdownMenu.classList.remove('show');

      // Find and update the toggle button
      const toggleId = dropdownMenu.getAttribute('aria-labelledby');
      if (toggleId) {
        const toggle = document.getElementById(toggleId);
        if (toggle) {
          toggle.classList.remove('show');
          toggle.setAttribute('aria-expanded', 'false');
          // Fokus vom Toggle nehmen, damit dessen Fokusring nicht kurz
          // aufblitzt, sobald er beim Schließen wieder sichtbar wird.
          if (document.activeElement === toggle) {
            toggle.blur();
          }
        }
      }
    }
  });
})();
// Mobile Menü Back Navigation END
